import {
    attachModuleToEl,
    detachModulesFromEl,
    destroy,
    describeDomElement,
    destroyObj,
    defineModule,
    getModule,
    getStoreObj,
    init,
    storeObj,
    triggerModule,
    triggerModules,
    observer,
} from './core';

export function install(Hop) {
    Hop.describeDomElement = describeDomElement;
    Hop.defineModule = defineModule;
    Hop.getModule = getModule;
    Hop.storeObj = storeObj;
    Hop.getStoreObj = getStoreObj;
    Hop.destroyObj = destroyObj;
    Hop.attachModuleToEl = attachModuleToEl;
    Hop.detachModulesFromEl = detachModulesFromEl;
    Hop.control = {
        destroy,
        init,
        triggerModule,
        triggerModules,
    };

    observer.start();
}

